import { render, staticRenderFns } from "./SvgMerchEffect.vue?vue&type=template&id=52cab054"
import script from "./SvgMerchEffect.vue?vue&type=script&lang=js"
export * from "./SvgMerchEffect.vue?vue&type=script&lang=js"
import style0 from "./SvgMerchEffect.vue?vue&type=style&index=0&id=52cab054&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports